"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const CalendarMoney = createSVGIcon(
  <>
    <path
      d="M0.333984 1.66748H15.6673V15.6675H0.333984V1.66748Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66748 0.333984V3.66732"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.334 0.333984V3.66732"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.333984 5.00049H15.6673"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00049 12.666V13.9993"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00049 6.66602V7.99935"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.66748 12.6662H9.16748C9.4769 12.6662 9.77365 12.5433 9.99244 12.3245C10.2112 12.1057 10.3341 11.8089 10.3341 11.4995C10.3341 11.1901 10.2112 10.8933 9.99244 10.6746C9.77365 10.4558 9.4769 10.3328 9.16748 10.3328H6.83415C6.52473 10.3328 6.22798 10.2099 6.00919 9.99114C5.7904 9.77234 5.66748 9.4756 5.66748 9.16618C5.66748 8.85676 5.7904 8.56001 6.00919 8.34122C6.22798 8.12243 6.52473 7.99951 6.83415 7.99951H10.3341"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CalendarMoney",
  { viewBox: "0 0 16 16", titleAccess: "CalendarMoney", fill: "none" }
);
